import { Pipe, PipeTransform } from '@angular/core';

import { UnidadeNegocioMercado } from '../unidade-negocio-mercado';

@Pipe({
    name: 'unidadeNegocioMercadoFilter',
    pure: false
})
export class UnidadeNegocioMercadoFilterPipe implements PipeTransform {
    /** Filtra os mercados pelas unidades de negócios informadas informadas */
    transform(entities: UnidadeNegocioMercado[], idsUnidadesNegocios: number[] = []): UnidadeNegocioMercado[] {
        if (!entities) {
            return [];
        }
        // Retorna todos os mercados quando não for informada nenhuma unidade de negócio para filtar
        if (!idsUnidadesNegocios || idsUnidadesNegocios.length === 0) {
            return entities;
        }

        return entities.filter(entityFilter =>  idsUnidadesNegocios.includes(entityFilter.idUnidadeNegocio));
    }
}
